import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useSignOut } from 'src/api/provider';
import { ROOT_DOMAIN } from 'src/constants/environment';
import { validateCustomSchemeRedirectUri, validateRedirectUrl } from 'src/lib/utils/url';

const ALLOWED_MOBILE_SCHEMES = ['resq-facility://', 'resq-partner://'];

export const SignOut = () => {
    const signOut = useSignOut();
    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const appRedirectUri = params.get('app_redirect_uri') || '';
        const nextPath = params.get('next');
        const isMobile = params.get('mobile') === 'true';
        const isCli = params.get('cli') === 'true';
        const cliCallback = params.get('cli_callback') || '';
        const appType = params.get('app_type');
        let redirectTo = '/login';

        const hasValidMobileRedirect =
            appRedirectUri.length > 0 &&
            validateCustomSchemeRedirectUri(appRedirectUri, ALLOWED_MOBILE_SCHEMES);

        // Mobile login flow: redirect to /login with same params (logout-then-login pattern)
        // This ensures every mobile login starts with fresh cookies (no stale session issues)
        if (isMobile && appType && hasValidMobileRedirect) {
            redirectTo = `/login?${params.toString()}`;
        } else if (isCli && cliCallback) {
            // CLI login flow: redirect to /login with same params (logout-then-login pattern)
            // This ensures CLI auth always starts with fresh cookies (no stale session issues)
            redirectTo = `/login?${params.toString()}`;
        } else if (appRedirectUri) {
            console.warn('[SignOut] Rejected invalid mobile redirect URI:', appRedirectUri);
        }

        if (!isMobile && !isCli && nextPath && ROOT_DOMAIN) {
            if (validateRedirectUrl(nextPath, ROOT_DOMAIN)) {
                redirectTo = `/login?next=${encodeURIComponent(nextPath)}`;
            }
        }

        signOut(redirectTo);
    }, [signOut, location.search]);

    return null;
};
